import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Button, Group, Stack } from '@mantine/core';

/** Owned by G21 (plan.md S0). Screen-group layout: a sub-nav row + `<Outlet/>` for
 * the production + pack-conversion screens (mirrors purchasing-intake.tsx's
 * identical layout+Outlet pattern one level down). Includes stages/recipes config
 * (sole ownership, plan.md QC fix #2). */
export const Route = createFileRoute('/_authenticated/production-packconv')({
  component: ProductionPackconvLayout,
});

// Exported so nav.test.ts can assert NAV_SECTIONS' "Production & Packing" children
// mirror this verbatim (label + to + order) rather than drifting silently.
export const TABS: ReadonlyArray<{ to: string; label: string; exact: boolean }> = [
  { to: '/production-packconv', label: 'Record a shift', exact: true },
  { to: '/production-packconv/quick', label: 'Quick conversion', exact: false },
  { to: '/production-packconv/batches', label: 'Kiln batches', exact: false },
  { to: '/production-packconv/runs', label: 'Runs', exact: false },
  { to: '/production-packconv/pack-conversion', label: 'Pack conversion', exact: false },
  { to: '/production-packconv/stages', label: 'Stages & recipes', exact: false },
];

function ProductionPackconvLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <Stack gap="lg">
      <Group gap="xs" wrap="wrap">
        {TABS.map((tab) => {
          const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to);
          return (
            <Button key={tab.to} component={Link} to={tab.to} variant={active ? 'filled' : 'light'} size="sm">
              {tab.label}
            </Button>
          );
        })}
      </Group>
      <Outlet />
    </Stack>
  );
}
